const getSprints = state => state.sprints;

// eslint-disable-next-line import/no-anonymous-default-export
export default { getSprints };
